import { ResourceProps } from "react-admin";
import { UsersList, UsersShow } from "./components";

export const usersResource: Omit<ResourceProps, "name"> = {
  list: UsersList,
  show: UsersShow,
};
